import { apiFetchJson } from '@wundo/client/api.ts';

/** A cohort as a form offers it: enough to pick one and name it. */
export interface CohortOption {
  id: string;
  /** The cohort's name, or the readable id it always has when it has none. */
  title: string;
  /** The track the cohort runs, so a picker can group cohorts under it. */
  trackId: string | null;
}

/** What the cohorts endpoint answers with. Only what a picker needs is read. */
interface CohortListResponse {
  data: {
    id: string;
    external_id: string;
    title: string | null;
    track_id: string | null;
  }[];
}

/**
 * The organisation's cohorts, for the admins who target something at one.
 *
 * One page of a hundred rather than a paged list: this feeds a dropdown, and
 * an organisation running more cohorts than that at once is not a thing that
 * exists yet. The organisation is named explicitly: the endpoint scopes an
 * admin to their own organisation by itself, but answers a superadmin with
 * every organisation's cohorts unless told whose it wants.
 */
export async function fetchCohorts(organisationId: string): Promise<CohortOption[]> {
  const params = new URLSearchParams({ limit: '100', organisation_id: organisationId });
  const { data } = await apiFetchJson<CohortListResponse>(`/cohorts?${params}`);

  return data.map((cohort) => ({
    id: cohort.id,
    title: cohort.title ?? cohort.external_id,
    trackId: cohort.track_id,
  }));
}
